/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { push } from 'react-router-redux';
import * as embedAPIUtil from 'utils/api/embed';
import { batchActions } from 'redux-batched-actions';



/* ========== ~~~~~~~~~~ EMBEDS STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers
import { failedApiCallReroute } from 'utils/messages';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
// import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { receiveEmbedData } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { receiveContentData } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayModal } from 'state/actions/modal_status';
import { displayErrorMessage, displaySuccessMessage } from 'utils/messages';




/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const RECEIVE_CLIENT_EMBEDS_DATA = 'RECEIVE_CLIENT_EMBEDS_DATA';
export const REMOVE_EMBED_DATA = 'REMOVE_EMBED_DATA';

const receiveClientEmbedsData = data => ({
    type: RECEIVE_CLIENT_EMBEDS_DATA,
    data
});

export const removeEmbedData = embedUUID => ({
    type: REMOVE_EMBED_DATA,
    embedUUID
});

export const getClientEmbedsData = (accountUUID, callback=null) =>  dispatch => (
    embedAPIUtil.getClientEmbedsData(accountUUID)
        .then(response => dispatch(receiveClientEmbedsData(response.data)))
        .then(() => { if(!!callback && typeof callback === 'function') callback() })
        .catch(err => dispatch(failedApiCallReroute(err.response.status)))
            // err => (sendMessage('Application Error. Code 001.')))
);

export const editEmbed = embedUUID => dispatch => (
    embedAPIUtil.getEmbedByUUID(embedUUID)
        .then(response => dispatch(batchActions([
            receiveEmbedData({ ...response.data.embed, ...response.data.site }),
            receiveContentData(response.data.contents),
        ])))
        .then(() => dispatch(updatePageDetails('dashboard/embeds/management/customize')))
        .then(() => dispatch(updateStepDetails('customize')))
        .then(() => dispatch(changePage('dashboard/embeds/management/customize')))
        .catch(err => dispatch(failedApiCallReroute(err.response.status)))
);

export const viewAnalytics = (embedUUID, accountUUID) => dispatch => {
    if(accountUUID){
        embedAPIUtil.getClientEmbedsData(accountUUID)
            .then(response =>{
                dispatch(receiveClientEmbedsData(response.data));
                dispatch(analyticsBatchedActions(embedUUID))
            })
            .catch(err => dispatch(failedApiCallReroute(err.response.status)));
    } else {
        dispatch(analyticsBatchedActions(embedUUID))
    }
};

const deleteEmbedFail = (callback) => dispatch => {
    if (!!callback && typeof callback === 'function') callback();
    return dispatch(
        batchActions([
            displayModal(false),
            displayErrorMessage('There was an issue deleting your embed')]
        ));
};

export const deleteEmbed = (embedUUID, accountUUID, callback) => dispatch => (
    embedAPIUtil.deleteEmbedByUUID(embedUUID)
        .then(() => dispatch(removeEmbedData(embedUUID)))
        .then(() => dispatch(displayModal(false)))
        .then(() => dispatch(displaySuccessMessage('We have successfully deleted your embed')))
        .then(() => dispatch(getClientEmbedsData(accountUUID, callback)))
        .catch(() => dispatch(deleteEmbedFail(callback)))
);

const analyticsBatchedActions = (embedUUID) => dispatch => embedAPIUtil.getEmbedAnalyticsByUUID(embedUUID)
    .then(response => dispatch(batchActions([
        receiveEmbedData({...response.data.embed, ...response.data.site}),
        receiveContentData(response.data.contents),
    ])))
    .then(() => dispatch(updatePageDetails('dashboard/embeds/management/embedcontent')))
    .then(() => dispatch(updateStepDetails('customize')))
    .then(() => dispatch(changePage('dashboard/embeds/analytics/embedcontent')))
    .catch(err => dispatch(failedApiCallReroute(err.response.status)));

export const moveToLibraryWithFetch = accountUUID => dispatch => (
    embedAPIUtil.getClientEmbedsData(accountUUID)
        .then(response => dispatch(receiveClientEmbedsData(response.data)))
            // err => (sendMessage('Application Error. Code 002.')))
        .then(() => dispatch(updatePageDetails('library')))
        .then(() => dispatch(changePage('dashboard/embeds')))
        .catch(err => dispatch(failedApiCallReroute(err.response.status)))
        // .then(() => dispatch(resetEmbedState()))
        // .then(() => dispatch(resetContentState()))
);
